/*This function will return the index of that element in the array which is just less than or equal to the passed element
for eg., for arr=[1,2,3,5] and element=4 ==> it will return index of 3 which is 2.
for arr=[1,2,3,4] and element=4 ==> it will return index of 4 which is 3.
*/

export const binarySearchLte = (arr, element) => {
  if (arr[0] > element) return -1;

  const index = binarySearchHelper(arr, element, 0, arr.length - 1);

  if (arr[index] > element) return index - 1;
  return index;
};

/*This function will return the index of that element in the array which is just greater than or equal to the passed element
for eg., for arr=[1,2,3,5] and element=4 ==> it will return index of 5 which is 3.
for arr=[1,2,3,4] and element=4 ==> it will return index of 4 which is 3.
*/

export const binarySearchGte = (arr, element) => {
  if (arr[arr.length - 1] < element) return -1;
  const index = binarySearchHelper(arr, element, 0, arr.length - 1);
  return index;
};
const binarySearchHelper = (arr, element, start, end) => {
  if (start > end) return;
  if (start == end) return start;

  //Covering a special Test case of size 2 Length array
  if (start == end - 1) {
    if (element > arr[start]) return end;
    return start;
  }

  let mid = Math.floor((start + end) / 2);

  if (arr[mid] == element) return mid;
  else if (arr[mid] > element) {
    return binarySearchHelper(arr, element, start, mid - 1);
  } else {
    return binarySearchHelper(arr, element, mid + 1, end);
  }
};
